module.exports = __webpack_public_path__ + "en-564.svg";